import { useState } from 'react';
import { Switch } from '../ui/switch';
import { formatCurrency } from '../../lib/defaultData';

export default function PriceSummary({
  subtotal, gstEnabled, onToggleGst, gstAmount, total,
  amountEnabled = true, manualSubtotal = 0, onUpdateManualSubtotal,
}) {
  const [focusedManual, setFocusedManual] = useState(false);

  return (
    <div
      className="py-8 border-t"
      style={{ borderColor: 'rgba(201,168,76,0.2)' }}
      data-testid="price-summary"
    >
      <h2 className="section-heading">Price Summary</h2>

      <div className="max-w-[400px] ml-auto space-y-1">
        {/* Subtotal */}
        <div className="price-row">
          <span className="text-sm font-medium text-[#2c2c2c]">Subtotal</span>
          {amountEnabled ? (
            <span className="font-mono font-semibold text-[#1a1a2e]" data-testid="subtotal-value">
              {formatCurrency(subtotal)}
            </span>
          ) : (
            <div className="relative">
              <span className="absolute left-2 top-1/2 -translate-y-1/2 text-[#1a1a2e]/40 text-sm">$</span>
              <input
                type="text"
                value={focusedManual ? (manualSubtotal === 0 ? '' : manualSubtotal) : Number(manualSubtotal || 0).toFixed(2)}
                onChange={e => {
                  const raw = e.target.value.replace(/,/g, '');
                  if (raw === '' || !isNaN(raw)) {
                    onUpdateManualSubtotal(raw === '' ? 0 : parseFloat(raw));
                  }
                }}
                onFocus={() => setFocusedManual(true)}
                onBlur={() => {
                  setFocusedManual(false);
                  onUpdateManualSubtotal(Number(manualSubtotal) || 0);
                }}
                className="editable-field amount-input pl-6 text-[#1a1a2e] bg-transparent text-sm font-mono font-semibold w-[140px] text-right"
                placeholder="0.00"
                data-testid="subtotal-manual-input"
              />
            </div>
          )}
        </div>

        {/* GST Toggle */}
        <div className="price-row">
          <div className="flex items-center gap-3">
            <span className="text-sm font-medium text-[#2c2c2c]">Include GST (10%)</span>
            <Switch
              checked={gstEnabled}
              onCheckedChange={onToggleGst}
              data-testid="gst-toggle"
            />
          </div>
          {gstEnabled && (
            <span className="font-mono text-sm text-[#6b7280]" data-testid="gst-value">
              {formatCurrency(gstAmount)}
            </span>
          )}
        </div>

        {/* Total */}
        <div className="price-row price-row-total mt-2">
          <span>
            {gstEnabled ? 'Total incl. GST' : 'Total (excl. GST)'}
          </span>
          <span className="font-mono" data-testid="total-value">
            {formatCurrency(gstEnabled ? total : subtotal)}
          </span>
        </div>
      </div>
    </div>
  );
}
